export const findKeyByValue = <K extends string | number | symbol, V>(obj: Record<K, V>, value: V): K | undefined => {
  return (Object.entries(obj) as [K, V][]).find(([_, val]) => val === value)?.[0];
};
